import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { viewsAPI } from "../../../api/apiClient";
import Loading from "../../../Loading";
import "../../../css/Views/ParticipantsView.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faArrowLeft,
  faArrowRight,
  faSyncAlt
} from "@fortawesome/free-solid-svg-icons";
import getParticipantStatusStyle from "../../../utils/getParticipantStatusStyle";

const statusMap = {
  1: { label: "Nieukończona", color: "#7f8c8d" },
  2: { label: "Lista rezerwowa", color: "#e16a00" },
  3: { label: "Potwierdzona", color: "#0d8732" },
  4: { label: "Oczekuje na zal.", color: "#0081d7" },
  5: { label: "Anulowana", color: "#b91100" },
  6: { label: "Usunięta", color: "#363636" },
};

const ParticipantsView = () => {
  const { callApi, isLoading } = useApi();

  const [groups, setGroups] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [tripsWithVariants, setTripsWithVariants] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 40;
  const [totalCount, setTotalCount] = useState(0);
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [lastSearchTrip, setLastSearchTrip] = useState(null);
  const [lastSearchVariant, setLastSearchVariant] = useState(null);

  const fetchParticipants = () => {
    callApi(
      () =>
        viewsAPI.getGroupedParticipants({
          nameSearch: searchTerm,
          tripGuid: selectedTrip,
          variantGuid: selectedVariant,
          page,
          pageSize,
        }),
      (data) => {
        setGroups(data.items);
        setTotalCount(data.totalCount);
      }
    );
  };

  const fetchTrips = () => {
    callApi(() => viewsAPI.getTripsWithVariants(), setTripsWithVariants);
  };

  useEffect(() => {
    fetchTrips();
  }, []);

  useEffect(() => {
    fetchParticipants();
  }, [page, searchTrigger]);

  const handleSearchClick = () => {
    setPage(1);
    setSearchTrigger((v) => v + 1);
    setHasSearched(true);
    setLastSearchTrip(selectedTrip);
    setLastSearchVariant(selectedVariant);
  };

  const maxPage = Math.ceil(totalCount / pageSize);

  const hideTripAndDiscord =
    lastSearchTrip !== null || lastSearchVariant !== null;

  return (
    <div id="participants-view" className="bank-transfers-view">
      <div className="bank-header with-refresh">
        Osoby uczestniczące
        <FontAwesomeIcon
          icon={faSyncAlt}
          className="refresh-icon"
          onClick={handleSearchClick}
          title="Odśwież wyniki"
        />
      </div>

      <div className="participant-search-bar">
        <input
          type="text"
          placeholder="Szukaj po imieniu..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />

        <select
          value={selectedTrip || ""}
          onChange={(e) => {
            setSelectedTrip(e.target.value || null);
            setSelectedVariant(null);
          }}
          className="search-select"
        >
          <option value=""> --- Wszystkie wycieczki ---</option>
          {tripsWithVariants.map((trip) => (
            <option key={trip.tripGuid} value={trip.tripGuid}>
              {trip.tripName}
            </option>
          ))}
        </select>

        <select
          value={selectedVariant || ""}
          onChange={(e) => setSelectedVariant(e.target.value || null)}
          disabled={!selectedTrip}
          className="search-select"
        >
          <option value="">--- Wszystkie warianty ---</option>
          {tripsWithVariants
            .find((t) => t.tripGuid === selectedTrip)
            ?.variants.map((variant) => (
              <option key={variant.variantGuid} value={variant.variantGuid}>
                {variant.variantName}
              </option>
            ))}
        </select>

        <button onClick={handleSearchClick} className="search-button">
          <FontAwesomeIcon icon={faSearch} /> Szukaj
        </button>
      </div>

      {isLoading && <Loading text="Ładowanie uczestników..." />}

      

      {!isLoading && hasSearched && groups.length === 0 && (
        <p>Brak osób uczestniczących do wyświetlenia.</p>
      )}

      {!isLoading && groups.length > 0 && (
        <>
          <div className="table-responsive">
            <table className="transfers-table">
              <thead>
                <tr>
                  <th>Imię</th>
                  {!hideTripAndDiscord && <th>Wycieczka</th>}
                  <th>Status rezerwacji</th>
                  <th>Status osoby</th>
                  {!hideTripAndDiscord && <th>Discord</th>}
                </tr>
              </thead>

              <tbody>
                {groups.map((group) =>
                  group.participants.map((p, index) => {
                    const participantStyle = getParticipantStatusStyle(
                      p.participantStatus
                    );

                    return (
                      <tr key={p.guid}>
                        {index === 0 && (
                          <td
                            rowSpan={group.participants.length}
                            style={{
                              fontWeight: "bold",
                              verticalAlign: "top",
                            }}
                          >
                            {group.preferredName}
                          </td>
                        )}

                        {!hideTripAndDiscord && (
                          <td>
                            {p.tripName} – {p.variantName}
                          </td>
                        )}

                        <td>
                          {statusMap[p.reservationStatus] ? (
                            <span
                              style={{
                                color:
                                  statusMap[p.reservationStatus].color,
                                fontWeight: "bold",
                              }}
                            >
                              {statusMap[p.reservationStatus].label}
                            </span>
                          ) : (
                            <span style={{ color: "#7f8c8d" }}>
                              Nieznany
                            </span>
                          )}
                        </td>

                        <td>
                          <span className={participantStyle.statusClass}>
                            <i
                              className={`fa-solid ${participantStyle.icon}`}
                            ></i>{" "}
                            {participantStyle.label}
                          </span>
                        </td>

                        {!hideTripAndDiscord && (
                          <td className="match-status-icon">
                            {p.onDiscord && (
                              <i
                                className="fa-brands fa-discord"
                                title="Discord"
                                style={{ color: "#5865F2" }}
                              ></i>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination-controls">
            {page > 1 && (
              <div onClick={() => setPage((p) => p - 1)}>
                <FontAwesomeIcon icon={faArrowLeft} /> Poprzednia
              </div>
            )}

            <span>
              Strona {page} z {maxPage}
            </span>

            {page < maxPage && (
              <div onClick={() => setPage((p) => p + 1)}>
                Następna <FontAwesomeIcon icon={faArrowRight} />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ParticipantsView;